<ng-container *ngFor="let breadcrumb of breadcrumbs;let i=index">
    <ng-container *ngIf="i !== 0">
        <span class="divider">/</span>
    </ng-container>
    <ng-container *ngIf="breadcrumb.url">
        <a [routerLink]="breadcrumb.url" class="breadcrumb-tab">{{ breadcrumb.label }}</a>
    </ng-container>
    <ng-container *ngIf="!breadcrumb.url">
        <div class="breadcrumb-tab">{{ breadcrumb.label }}</div>
    </ng-container>
</ng-container>
<div class="version">v.{{ appService?.currentRelease }}</div>

